export const disableActionsByDefaultModal = (columnId: string) => {
  return (
    columnId === 'empresa-codigo-id' ||
    columnId === 'cd-loja-codigo-id' ||
    columnId === 'valor-estoque-atual-id' ||
    columnId === 'valor-estoque-transito-id' ||
    columnId === 'valor-estoque-reservado-id' ||
    columnId === 'valor-estoque-excesso-id' ||
    columnId === 'valor-estoque-falta-id' ||
    columnId === 'ruptura-num-sku-id' ||
    columnId === 'ruptura-porcentagem-id' ||
    columnId === 'produto-codigo-id' ||
    columnId === 'produto-material-id'
  )
}
